import React from 'react';

import Link from 'buyside/components/presentation/Link/link';

import { userUrl } from 'buyside/util/urlHelper';

const UserLink = ({ user }) => {
  return <Link to={userUrl(user.id)}>{user.displayName}</Link>;
};

export default UserLink;
